import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../modules/Admin/services/AuthService';
import axios from 'axios';
import SideBar from '../shared/Sidebar/EmployeeSidebar/Sidebar';
import AdminSidebar from '../shared/Sidebar/AdminSidebar/AdminSidebar';
import SuperAdminSidebar from '../shared/Sidebar/SuperAdminSidebarMenu/SuperAdminSidebar';
import FirstLoginTour from '../shared/Tour/FirstLoginTour';
import { ensureSubscriptionChecked } from '../shared/utils/subscriptionAccessStore';

const AppRoute = ({ children }) => {
  const currentRole = AuthService.getLoggedInRoleId();
  const roleNumSidebar = parseInt(currentRole, 10);
  const isTenantUser = roleNumSidebar !== 1;
  const [subscriptionReady, setSubscriptionReady] = useState(!isTenantUser);
  const [subscriptionActive, setSubscriptionActive] = useState(true);

  useEffect(() => {
    axios.defaults.withCredentials = true;
    const token = AuthService.getToken();
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  useEffect(() => {
    if (!isTenantUser) return undefined;
    let cancelled = false;
    ensureSubscriptionChecked().then((active) => {
      if (!cancelled) {
        setSubscriptionActive(active);
        setSubscriptionReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isTenantUser]);

  const Role = {
    SUPERADMIN: { roleId: 1, roleName: 'SuperAdmin' },
    ADMIN: { roleId: 2, roleName: 'Admin' },
    EMPLOYEE: { roleId: 4, roleName: 'Employee' },
  };

  const chrome = (children) => (
    <>
      <FirstLoginTour />
      {children}
    </>
  );

  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (isTenantUser && !subscriptionReady) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#8392ab', fontSize: '14px' }}>
        <i className="fas fa-circle-notch fa-spin me-2" />
        Checking workspace access…
      </div>
    );
  }

  if (isTenantUser && !subscriptionActive) {
    return <Navigate to="/subscription-inactive" replace />;
  }

  const AppFooter = () => (
    <footer style={{
      marginTop: "32px",
      borderTop: "1px solid #e9ecef",
      background: "#fff",
      padding: "16px 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "8px",
    }}>
      <p style={{ margin: 0, fontSize: "13px", color: "#8392ab", fontWeight: "500" }}>
        <i className="fas fa-copyright" style={{ marginRight: "5px", color: "#344767" }} />
        {new Date().getFullYear()}{" "}
        <span style={{ color: "#344767", fontWeight: "600" }}>NextFollowUp</span>
        {" "}— All rights reserved.
      </p>
      <p style={{ margin: 0, fontSize: "12px", color: "#8392ab" }}>
        Designed &amp; Developed by{" "}
        <a
          href="https://amritweb.in/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#5e72e4", fontWeight: "700", textDecoration: "none" }}
          onMouseOver={(e) => e.target.style.textDecoration = "underline"}
          onMouseOut={(e) => e.target.style.textDecoration = "none"}
        >
          Amrit Web (OPC) Pvt. Ltd.
        </a>
      </p>
    </footer>
  );

  return (
    <div className="main-layout">
     {roleNumSidebar === Role.SUPERADMIN.roleId ? (
        <SuperAdminSidebar>
          {chrome(
            <div className="">
              {children}
              <AppFooter />
            </div>
          )}
        </SuperAdminSidebar>
      ) : roleNumSidebar === Role.ADMIN.roleId || roleNumSidebar === 3 ? (
        <AdminSidebar>
          {chrome(
            <div className="">
              {children}
              <AppFooter />
            </div>
          )}
        </AdminSidebar>
      ) : (
        <SideBar>
          {chrome(
            <div className="">
              {children}
              <AppFooter />
            </div>
          )}
        </SideBar>
      )}
    </div>
  );
};



export default AppRoute;
